<form
  *transloco="let t; read: 'configuration-routes.view.settings-tab'"
  [formGroup]="form"
  class="configuration-route-details__form"
>
  <div class="xi-form-group__side--left">
    <h3>{{ t('details-header') }}</h3>

    <p>{{ t('details-content') }}</p>
  </div>

  <div class="xi-form-group__side--right">
    @if (!isLoadingName) {
      <div>
        <xi-input-field
          [placeholder]="t('name-placeholder')"
          name="configuration-route-name"
          [label]="t('name')"
          formControlName="configName"
          [status]="configNameStatus"
          required
          autocomplete="off"
          [readonly]="!canEditRoute"
          [prePopulateStatus]="true"
        ></xi-input-field>
      </div>
    }
    @if (!isLoadingNotes) {
      <div>
        <xi-text-area
          [label]="t('notes')"
          formControlName="configNotes"
          [readonly]="!canEditRoute"
        ></xi-text-area>
      </div>
    }
  </div>
</form>
